'use client'

import { EveLogo } from '../eve-logo/EveLogo'
import styles from './SimpleHeader.module.css'

export function SimpleHeader() {
  return (
    <header className={styles.simpleHeader}>
      <div className={styles.simpleHeaderInner}>
        <EveLogo />
      </div>
    </header>
  )
}
